import React, { useState, useEffect } from 'react';
import { AiFillPlusCircle } from 'react-icons/ai';
import { FiBatteryCharging } from 'react-icons/fi';
import { GiBigGear } from 'react-icons/gi';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { IoMdList } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { getFloatAccounts } from '../service/floatService';
import Input from '../common/Input';
import DataTable from '../common/DataTable';
import AdminNavigation from './AdminNavigation';
import TooltipBox from '../common/TooltipBox';
import { toast } from 'react-toastify';

export default function FloatList(props) {
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const [accounts, setAccounts] = useState([]);
   const pageSize = 50;
   const columns = [
      {
         columnCaption: 'Account Id',
         columnKey: 'floatAccountId',
         // content: (item) => <Link to={`/User/${item.floatAccountId}`}>{item.floatAccountId}</Link>,
      },
      {
         columnCaption: 'Account Name',
         columnKey: 'floatAccountName',
      },
      {
         columnCaption: 'Unit Id',
         columnKey: 'unitId',
      },
      {
         columnCaption: 'Float Balance',
         columnKey: 'floatAccountBalance',
         content: (item) => <span style={{ color: '#38a8ed' }}>{formatNumber(item.floatAccountBalance)}</span>,
      },
      {
         columnCaption: 'Warning Balance',
         columnKey: 'refillWarningBalance',
         content: (item) => <>{formatNumber(item.refillWarningBalance)}</>,
      },
      {
         columnCaption: 'Unit Type',
         columnKey: 'vendingUnitType',
      },
      {
         columnCaption: 'Action',
         content: (item) => (
            <>
               <span className='mr-3'>
                  <Link to={`/User/${item.userId}`}>
                     <TooltipBox text='Recharge' component={<FiBatteryCharging style={iconStyleCharging} />} />
                  </Link>
               </span>
               <span className='mr-3'>
                  {/* <Link to={`/User/${item.userId}`}> */}
                  <TooltipBox text='Disable' component={<IoIosCloseCircleOutline style={iconStyleDisable} />} />
                  {/* </Link> */}
               </span>
            </>
         ),
      },
   ];
   const onSearch = (e) => {
      e.preventDefault();
   };

   const formatNumber = (input) => {
      return new Intl.NumberFormat('en-US', {}).format(input);
   };

   const fetchFloatAccounts = () => {
      getFloatAccounts()
         .then((response) => {
            const floats = response.data.data;
            setItems(floats);
            setAccounts(floats);
         })
         .catch((error) => {
            toast.error('Cannot fetch float account', { autoClose: 2000 });
         });
   };

   const refresh = () => {
      getFloatAccounts()
         .then((response) => {
            const floats = response.data.data;
            setItems(floats);
            setAccounts(floats);
         })
         .catch((error) => {
            toast.error('Cannot fetch float account', { autoClose: 2000 });
         });
   };

   useEffect(fetchFloatAccounts, []);

   const iconStyle = {
      color: '#2c62a9',
      fontSize: 30,
      cursor: 'pointer',
   };

   const iconStyleCharging = {
      color: '#2c62a9',
      fontSize: 15,
      cursor: 'pointer',
   };

   const iconStyleFloat = {
      color: '#1D7500',
      fontSize: 15,
      cursor: 'pointer',
   };

   const iconStyleDisable = {
      color: '#A70329',
      fontSize: 15,
      cursor: 'pointer',
   };

   return (
      <>
         <div className='container'>
            <div className='row'>
               <div className='col-md-3'>
                  <AdminNavigation />
               </div>
               <div className='col-md-9'>
                  <h4 className='text-muted ml-1 mb-2 font-italic'>Float Accounts</h4>

                  <div className='mb-1'>
                     <AiFillPlusCircle style={iconStyle} />
                  </div>
                  <div className='d-flex '>
                     <div className='input-group input-group-sm mb-3 mr-sm-2'>
                        <div className='input-group-prepend'>
                           <div className='input-group-text'>
                              <IoMdList />
                           </div>
                        </div>
                        <Input
                           name='searchBox'
                           type='text'
                           className='form-control custom-input'
                           id='searchBox'
                           value={filterValue}
                           placeholder=''
                           onChange={onSearch}
                        />
                     </div>
                  </div>
                  <div className='custom-table-box table-responsive'>
                     <DataTable items={items} pageSize={pageSize} fontClassName={'table-font-sm'} columns={columns}></DataTable>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}
